import { FETCH_GLOBAL_ACCOUNTS_FAILURE, FETCH_GLOBAL_ACCOUNTS_REQUEST, FETCH_GLOBAL_ACCOUNTS_SUCCESS } from "../../actions/globalAccounts/globalAccountsActions";

const initialState = {
  globalAccountsLoading: true,
  globalAccountsData: [],
  globalAccountsError: null,
};

const globalAccountsReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_GLOBAL_ACCOUNTS_REQUEST:
      return { ...state, globalAccountsLoading: true, payload: action.payload };
    case FETCH_GLOBAL_ACCOUNTS_SUCCESS:
      return {
        ...state,
        globalAccountsLoading: false,
        globalAccountsData: action.payload,
      };
    case FETCH_GLOBAL_ACCOUNTS_FAILURE:
      return {
        ...state,
        globalAccountsLoading: false,
        globalAccountsError: action.payload,
      };
    default:
      return state;
  }
};

export default globalAccountsReducer;
